export default __webpack_public_path__ + "static/media/promo component.d7d8a58f.png";